import React from "react";
import defaultStore from "../assets/img/user6.png";
import { Link } from "react-router-dom";

const RestaurantCard = ({ restaurant }) => {
  return (
    // <Link to={`/shop-details`}>
    <Link to={`/shop-details/${restaurant?.id}`}>
      <div className="restaurant-card">
        <div
          className="card-image"
          style={{
            backgroundImage: `url(${
              restaurant?.profilePic?.fileUrl || defaultStore
            })`,
          }}
        >
          <div className="rating-badge">
            <span className="rating-percentage">
              {restaurant?.rating ? `${restaurant?.rating}%` : "New"}
            </span>
            <span className="rating-count">({restaurant?.reviews}+)</span>
          </div>
        </div>
        <div
          className="card-content d-flex"
          style={{ justifyContent: "space-between" }}
        >
          <h3 className="restaurant-name">{restaurant?.name}</h3>
          <span className="restaurant-category">
            {restaurant?.category ? restaurant?.category : "Local Food"}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default RestaurantCard;
